// eslint-disable-next-line import/prefer-default-export
import { types } from '../reducers/mainMenuReducer';

export const setMainMenu = (items) => ({
  type: types.SET,
  payload: items,
});

export const resetMainMenu = () => ({
  type: types.RESET,
});
